<template lang="html">
  <div class="main">
    <h2>Nuevo analisis de Portafolio</h2>
    <breadcrumbs class="breadcrumbs" section="3"></breadcrumbs>
    <h3 class="second-title">Confirmar Emisoras</h3>
    <el-row :gutter="20" style="margin-bottom:30px;">
      <el-col :span="6">
        <p class="subtitle">Emisoras</p>
      </el-col>
      <el-col :span="8" :offset="2">
        <div class="add-comment-button">
          <div class="container-edit-text">
          <router-link to="/registro-emisoras">
          <p>Agregar emisora</p>
          </router-link>
          </div>
        </div>
      </el-col>
      <el-col v-if="!comment && !showAddCommentInput" :span="8">
        <div class="add-comment-button" v-on:click="displayCommentInput()">
          <div class="container-edit-text">
            <i class="el-icon-edit text-icon"></i>
            <p>Agregar comentario</p>
          </div>
        </div>
      </el-col>
      <el-col v-if="comment && !showAddCommentInput" :span="8">
        <div class="add-comment-button" v-on:click="deleteComment()">
          <div class="container-edit-text">
            <p>Eliminar comentario</p><i class="el-icon-delete text-icon"></i>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-table :data="currentInvestments" >
      <el-table-column prop="assetClassLabel" label="Mercado" width="130"></el-table-column>
      <el-table-column prop="assetLabel" label="Emisora" width="130"></el-table-column>
      <el-table-column prop="totalSecurities" :label="percentageBasedPortfolio ? 'Porcentaje': 'Numero de titulos'" width="130">
        <template slot-scope="scope">
          <span> {{ formatSecurities(scope.row.totalSecurities) }} </span>
        </template>
      </el-table-column>
      <el-table-column prop="price_of_note" label="Precio de la nota" width="130">
        <template slot-scope="scope">
          <span> {{ formatPrice(scope.row.price_of_note) }} </span>
        </template>
      </el-table-column>
      <el-table-column prop="totalAmount" label="Monto invertido" width="130">
        <template slot-scope="scope">
          <span> {{ formatPrice(scope.row.totalAmount) }} </span>
        </template>
      </el-table-column>
      <el-table-column prop="index" width="30">
        <template slot-scope="scope">
          <i v-if="!percentageBasedPortfolio" class="el-icon-circle-close-outline" v-on:click="_deleteAsset(scope.$index)"></i>
        </template>
      </el-table-column>
    </el-table>
    <div v-show="showAddCommentInput" class="commentInput-container">
      <el-input type="textarea" :rows="4" placeholder="Agregar comentario..." v-model="comment"></el-input>
      <el-row type="flex" justify="end" v-show="showAddCommentInput">
        <el-button size="small"  v-on:click="addComment()">Agregar</el-button>
      </el-row>
    </div>
    <div v-show="displayCommentSection" class="comment-container">
      <span class="comment-title">Comentario:</span>
      <span>{{ comment }}</span>
    </div>
    <div class="bottom-section">
      <el-row :gutter="20" type="flex" justify="space-between">
        <el-col :span="8">
          <div class="container-back-button">
            <router-link to="/registro-emisoras">
              <i class="el-icon-arrow-left blue-arrow-icon"></i>
              <p class="back-button">Atrás</p>
            </router-link>
          </div>
        </el-col>
        <el-col :span="8">
          <p class="blue-extended-button" v-on:click="submitPortfolio(1)">Guarda borrador</p>
        </el-col>
        <el-col :span="8">
          <p class="blue-extended-button" v-on:click="submitPortfolio(2)">Generar análisis</p>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import breadcrumbs from './Breadcrumbs';
import { createPortfolio } from '@/graphql';

export default {
  components: {
    breadcrumbs
  },
  data () {
    return {
      formattedData: [],
      showAddCommentInput: false,
      displayCommentSection: false,
      advisorComment: '',
      comment: '',
      bType: 1,
    }
  },
  mounted() {
    if (this.formMode !== 1 && this.$store.getters.getAdvisorComment) {
      this.comment = this.$store.getters.getAdvisorComment
      this.displayCommentSection = true
    }
  },
  computed: {
    currentPortfolioId: function () {
      return this.$store.getters.getSelectedPortfolio
    },
    formMode: function () {
      return this.$store.getters.getFormMode
    },
    currentInvestments: function () {
      return this.$store.getters.getTransmitersData
    },
    advisorId: function () {
      return parseInt(this.$store.getters.userInfo.id)
    },
    generalData: function () {
      return this.$store.getters.getGeneralData
    },
    percentageBasedPortfolio: function () {
      return this.$store.getters.getFormValueTypes
    }
  },
  methods: {
    displayCommentInput(){
      this.showAddCommentInput = true
    },
    addComment() {
      this.showAddCommentInput = false
      this.advisorComment = this.comment
      this.displayCommentSection = true
    },
    deleteComment() {
      this.comment = ''
      this.advisorComment = ''
      this.displayCommentSection = false
    },
    formatPrice (price) {
      return  price % 1 !== 0 ? `$${price.toFixed(2).toLocaleString()}` : `$${price.toLocaleString()}`
    },
    formatSecurities(amount) {
      if (this.percentageBasedPortfolio) {
        return amount % 1 !== 0 ? `${amount.toFixed(2)}%` : `${amount}%`
      } else {
        return  amount % 1 !== 0 ? amount.toFixed(2).toLocaleString() : amount.toLocaleString()
      }
    },
    _deleteAsset(assetIndex){
      this.$confirm('Desea eliminar esta emisora. Continuar?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch( 'deleteInvestment', assetIndex)
        this.$message({
          type: 'success',
          message: 'Eliminación completada'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Eliminación cancelada'
        });
      });
    },
    submitPortfolio (bType) {
      this.formatData(this.currentInvestments)
      this.bType = bType
      this.$apollo.mutate({
        mutation: createPortfolio,
        variables: {
          advisorId: this.advisorId,
          cuttofDate: this.generalData.cutoff_date,
          clientId: this.generalData.clientId,
          contractNumber: this.generalData.contract_number,
          investments: this.formattedData,
          advisorComment: this.advisorComment,
          mode: this.formMode,
          bType: this.bType,
          portfolioId: this.currentPortfolioId ? parseInt(this.currentPortfolioId) : undefined
        }
      }).then((data) => this.requestSuccess(data.data.createPortfolio)
      ).catch(() => {
        this.$message({
          type: 'error',
          message: 'Ocurrió un error intenta más tarde'
        })
      })
    },
    requestSuccess (data) {
      this.$store.dispatch('resetPortfolioForm')
      if(this.bType === 2) {
        this.$router.push(`/analisis-portafolio/${data.portfolio.id}`)
      } else {
        this.$router.push('/lista-de-analisis')
      }
    },
    formatData (data) {
      const cleanData = []
      let asset = {}
      data.map(investment => {
        if (this.percentageBasedPortfolio) {
          asset = {
            idAsset: investment.idAsset,
            totalAmount: investment.totalAmount
          }
        } else {
          asset = {
            idAsset: investment.idAsset,
            totalAmount: investment.totalAmount,
            totalSecurities: investment.totalSecurities
          }
        }
        cleanData.push(asset)
      })
      this.formattedData = cleanData
    },

  }
}
</script>
<style scoped lang="css">
.el-textarea {
  margin-bottom: 10px;
}

a {
  text-decoration: none;
}

p {
  color: white;
}

/* Style for Add comment section */

.commentInput-container {
  margin: 20px 0;
  border-bottom: 1px solid #dcdfe6;
}

.comment-container {
    display: flex;
    padding: 20px 0;
    border-top: 1px solid #dcdfe6;
    flex-direction: column;
}

.comment-title {
  font-weight: bold;
}

.add-comment-button {
  cursor: pointer;
  background-color: #F1F1F1;
  border-radius: 3px;
  display: flex;
}

.container-edit-text {
  margin: 0 auto;
}

.container-edit-text  i {
  display: inline-block;
  margin: 0 5px;
}

.container-edit-text p {
  display: inline-block;
  padding: 10px 0;
  color: #2c3e50;
}

a {
  text-decoration: none;
}

p {
  margin: 0px;
}

hr {
  border-color: #4366DE;
  margin: 0px;
  margin-bottom: 2px;
}
h3 {
  font-weight: 400;
  position: relative;
  left: 4px;
}

.second-title {
  text-align: center;
  margin-bottom: 3em;
  font-size: 22px;
  font-weight: 600;
}

.subtitle {
  font-size: 22px;
  margin-bottom: 8px;
  color: #2c3e50;
}

.text-question {
  text-decoration: underline;
  cursor: pointer;
  margin-top: 6px;
  margin-left: auto;
  margin-right: 0px;
  display: block;
  width: 126px;
}

.blue-button {
  background-color: #4366DE;
  color: white;
  text-align: center;
  height: 38px !important;
  cursor: pointer;
  border-radius: 3px;
}

.blue-button p {
  padding: 10px;
}

.label {
  margin-top: 16px;
}

.main {
  display: block;
  margin: auto;
  width: 100%;
  max-width: 720px;
  margin-top: 2rem;
  padding: 1rem;
  box-sizing: border-box !important;
}

.el-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  height: 28px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.el-input__inner {
  height: 38px;
}

/* Style for the table */

.el-main {
  line-height: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.el-table {
  font-size: 12px;
  text-align: left;
}

/* Style for the cross icon */

.el-icon-circle-close-outline {
  float: right;
  font-size: 20px;
  cursor: pointer;
}

/* Style for date component */

.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100%;
}

.container-continue-button {
  display: block;
  width: 142px;
  margin-left: auto;
  margin-right: 0px;
  margin-top: 3em;
  margin-bottom: 3em;
}

.continue-button {
  cursor: pointer;
  margin-top: 6px;
  margin-left: auto;
  margin-right: 0px;
  display: inline-block;
  width: 115px;
  font-weight: 500;
  font-size: 22px;
  color: #4366DE;
}

.blue-arrow-icon {
  font-size: 22px;
  font-weight: 600;
  color: #4366DE;
  position: relative;
  top: 3px;
}

/* Style for bottom section */

.bottom-section {
  margin-top: 3em;
  margin-bottom: 3em;
}

.blue-extended-button {
  background-color: #4366DE;
  color: white;
  text-align: center;
  cursor: pointer;
  border-radius: 3px;
  display: inline-block;
  padding: 10px 0;
  position: relative;
  width: 100%;
}

.container-back-button {
  display: inline-block;
  cursor: pointer;
  position: relative;
  top: 6px;
}

.back-button {
  display: inline-block;
  font-weight: 500;
  font-size: 22px;
  color: #4366DE;
  margin-left: 24px;
}

.blue-arrow-icon {
  font-size: 22px;
  font-weight: 600;
  color: #4366DE;
  position: relative;
  top: 2px;
}

/* Table of  transmitters */

.list-container {
  padding: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/RegisterConfirmation.vue